<ng-container *transloco="let t; read: 'dashboard'">
  <ng-container *ngIf="ac">

    <div class="dashboard-block">
      <label>{{ t('overview.moderator') }}</label>
      <ul>
        <li>
          <app-participant
            [ac]="ac"
            [user]="ac.moderator"
          ></app-participant>
        </li>
      </ul>
    </div>
    <div class="dashboard-block">
      <label>{{ t('overview.candidates') }}</label>
      <ul>
        <li *ngFor="let candidate of ac.candidates">
          <app-participant
            [ac]="ac"
            [user]="candidate"
            [report]="resultReports?.[candidate.id] || null"
            (reportChange)="onReportChanged($event, candidate.id)"
          ></app-participant>
        </li>
      </ul>
    </div>
    <div class="dashboard-block">
      <label>{{ t('overview.observers') }}</label>
      <ul>
        <ng-container *ngFor="let observer of ac.observers">
          <li *ngIf="observer.role !== 'moderator'">
            <app-participant
              [ac]="ac"
              [user]="observer"
            ></app-participant>
          </li>
        </ng-container>
      </ul>
    </div>

  </ng-container>
</ng-container>
